<template>
  <component :is="to ? 'router-link' : 'a'" :href="to ? undefined : '#'" :to="to" class="card-footer-item"><slot /></component>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    to: {
      type: Object
    }
  }
})
</script>
